import constants from 'config/constants';

let api, clientId, redirectUri;
if (constants.ENV === 'local') {
  api = 'pk_test_HuI6SSXtonVWPdAeKXjZBq6h';
  clientId = 'ca_CRcsxlBqQ2BFpbpUO1t2xLabgOfasb6p';
  redirectUri = 'http://api.localhost';
} else if (constants.ENV === 'production') {
  api = 'pk_live_Sdphu6k9c5qBIVhnC1tOjIWM';
  clientId = 'ca_CRcsUBLxmo9oKQ9zILs17TnUKgv3uP5J';
  redirectUri = constants.BASE_API_URL + '/v1';
} else {
  api = 'pk_test_HuI6SSXtonVWPdAeKXjZBq6h';
  clientId = 'ca_CRcsxlBqQ2BFpbpUO1t2xLabgOfasb6p';
  redirectUri = constants.BASE_API_URL + '/v1';
}

export default {
  api,
  client_id: clientId,
  redirect_uri: `${redirectUri}/oauth/stripe`,
  response_type: 'code',
  scope: 'read_write',
  oauth_route: 'https://connect.stripe.com/oauth/authorize',
};
